import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React from 'react';
import { useWorkspaceFolder } from '../../provider';
import DocumentGrid from './document_grid';
const DocumentTab = () => {
    const { activeFolderId, documents, isLoadingDocuments, } = useWorkspaceFolder();
    const hasNoDocuments = activeFolderId && (!documents || (documents === null || documents === void 0 ? void 0 : documents.length) === 0);
    if (activeFolderId && documents && (documents === null || documents === void 0 ? void 0 : documents.length) > 0) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "saved-document-container" },
                React.createElement(DocumentGrid, null))));
    }
    return (React.createElement("div", { className: 'empty-document-container' },
        React.createElement(React.Fragment, null,
            isLoadingDocuments &&
                React.createElement(React.Fragment, null,
                    React.createElement("div", { className: 'loading-data-icon' },
                        React.createElement(LoadingElement, { isLightBackground: true }))),
            !isLoadingDocuments &&
                React.createElement("div", null,
                    React.createElement("span", { className: 'empty-document-svg' }),
                    React.createElement("div", { className: 'empty-folder-heading' }, hasNoDocuments
                        ? 'No Saved Documents'
                        : 'No folder is selected'),
                    React.createElement("div", { className: 'empty-folder-sub-heading' }, hasNoDocuments
                        ? 'Add documents from a document search'
                        : 'Please select a folder')))));
};
export default DocumentTab;
